/* eslint-disable no-unused-vars */
import { LocalStorage } from '../store/local-storage';
import axios from 'axios';
import { environment } from '../environments/environment';
import { toaster } from '../components/common/Toaster';
import { PortalApiToken } from '../services/api/api-token';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const baseURL = environment.baseURL;
const authorizationToken = 'Bearer ' + window.localStorage.getItem('accessToken');
const configParamsWithoutAuth = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    }
}




export const checkIfServerError = err => {
    if (err && err.response && err.response.status) {
        return (err.response.status).toString().startsWith('5');
    } else return false;
}

export function _logIn(email, password, rememberMe, securityHelper){
    const formData = { email: email, password: password }
    const loginResponse = axios.post(`${baseURL}/security/login`, formData, configParamsWithoutAuth);
    return loginResponse.then(data => {
        LocalStorage.saveAuthCredentials(email, email);
            LocalStorage.saveRememberMeData(email, rememberMe);
            const userData = {
                name: data?.data?.data?.displayName,
                email: data?.data?.data?.email,
                rememberMe
            };
            const userId = data?.data?.data?.id;
            const token = data?.data?.data?.token;
            const role = data?.data?.data?.userRole;
            window.localStorage.setItem('userDetails', JSON.stringify(userData));
            window.localStorage.setItem('userId', userId);
            window.localStorage.setItem('currentUser', JSON.stringify(role));
            window.localStorage.setItem('accessToken', token);
            PortalApiToken.initializeApiToken({accessToken: data?.data?.data?.token, refreshToken: data?.data?.data?.refreshToken});
            securityHelper && securityHelper.onUserAuthenticated({ email: email, userId: email, rememberMe: rememberMe });
            window.location.hash = 'home';
    }).catch(err =>{
        throw new Error("LOGIN.INVALID_CREDENTIALS");
    })
}

export async function _forgotPassword(email) {
    await axios.get(`${baseURL}/security/reset/${encodeURIComponent(email)}/password`, configParamsWithoutAuth).catch(err => checkIfServerError(err) ? toaster(`${err.message}`) : null);
    return;
}

export async function _changePassword(oldPassword, newPassword){
    const authorizationToken = 'Bearer ' + window.localStorage.getItem('accessToken');
    configParamsWithoutAuth['headers']['Authorization'] = authorizationToken;
    const formData = { currentpassword: oldPassword, newpassword: newPassword};
    return await axios.post(`${baseURL}/security/user/password`, formData, configParamsWithoutAuth)
    .then(() => {
        // Success
    })
    .catch((error) => {
        // Error
        if(checkIfServerError(error)){
            toaster(`${error.message}`);
        }
        if (error && Object.prototype.hasOwnProperty.call(error, 'message')) {
            throw new Error(error.message);
        }
        else {
            throw new Error('Something went wrong! Please contact administrator.');
        }
    });
}